(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/personalization-settings-panel/personalization-settings-panel.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/personalization-settings-panel/personalization-settings-panel.js');
'use strict';

const Checkbox = svs.ui.reactForm.Checkbox;
const {
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  putCustomersSettingsAsync,
  getCustomersSettingsAsync
} = svs.myProfile.react.pages.communicationSettings.personalizationSettings.personalizationSettingsService;
const {
  makeSetting
} = svs.myProfile.react.shared.helpers;
const {
  showSettingsTechnicalError,
  showNotLoggedInError
} = svs.myProfile.react.shared.dialogs;
const {
  trackPersonlization
} = svs.myProfile.react.shared.tracking;
const {
  PersonalizationSettingsSkeleton
} = svs.myProfile.react.pages.communicationSettings.personalizationSettings;
const {
  titles,
  icons
} = svs.myProfile.constants;

const PersonalizationSettingsPanel = _ref => {
  let {
    isAdaptContent
  } = _ref;
  const [isContentExternal, setisContentExternal] = React.useState(false);
  const [isContentSvs, setIsContentSvs] = React.useState(false);
  const [isPersonalizationSettingsLoaded, setIsPersonalizationSettingsLoaded] = React.useState(false);
  const adaptContentRef = React.useRef(null);
  React.useEffect(() => {
    if (isAdaptContent && adaptContentRef && isPersonalizationSettingsLoaded) {
      adaptContentRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isAdaptContent, isPersonalizationSettingsLoaded]);
  React.useEffect(() => {
    const getCS = async () => {
      try {
        const {
          settings,
          error
        } = await getCustomersSettingsAsync();
        if (error) {
          if (error.code === 100005) {
            showNotLoggedInError();
            return;
          }
          showSettingsTechnicalError();
        } else {
          setisContentExternal(settings === null || settings === void 0 ? void 0 : settings.personalizedContentExternal);
          setIsContentSvs(settings === null || settings === void 0 ? void 0 : settings.personalizedContentSvs);
          setIsPersonalizationSettingsLoaded(true);
        }
      } catch (error) {
        showSettingsTechnicalError();
      }
    };
    getCS();
  }, []);

  const updateSettings = async (key, val) => {
    try {
      await putCustomersSettingsAsync(makeSetting(key, val));
      trackPersonlization(key, val);
    } catch (error) {
      showSettingsTechnicalError('Ett fel inträffade när dina inställningar för anpassat innehåll skulle sparas, försök igen senare.');
    }
  };

  const handleContentExternal = e => {
    setisContentExternal(!isContentExternal);
    updateSettings(e.target.value, !isContentExternal);
  };

  const handleContentSvs = e => {
    setIsContentSvs(!isContentSvs);
    updateSettings(e.target.value, !isContentSvs);
  };

  return React.createElement(React.Fragment, null, !isPersonalizationSettingsLoaded && React.createElement(PersonalizationSettingsSkeleton, null), isPersonalizationSettingsLoaded && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "scroll-margin-adapted-content",
    ref: adaptContentRef
  }, React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.ADAPT,
    title: titles.ADAPT
  }), React.createElement("p", null, "Vi kan anv\xE4nda din anv\xE4ndardata f\xF6r att l\xE4ttare kunna visa inneh\xE5ll som \xE4r relevant f\xF6r dig."), React.createElement(Checkbox, {
    checked: isContentSvs,
    onChange: handleContentSvs,
    value: "personalizedContentSvs"
  }, "Jag vill ha relevant och anpassat inneh\xE5ll p\xE5 Svenska Spels webbplatser"))), React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.OFFERS,
    title: titles.OFFERS
  }), React.createElement("p", null, "Svenska Spel samarbetar med partners med egna kundregister som t ex sociala medier f\xF6r att anpassa annonsering och erbjudanden gentemot dig. Detta g\xF6r vi genom att delge v\xE5ra partners att du \xE4r kund hos oss."), React.createElement(Checkbox, {
    checked: isContentExternal,
    onChange: handleContentExternal,
    value: "personalizedContentExternal"
  }, "Ja, det \xE4r OK."))));
};
svs.myProfile.react.pages.communicationSettings.personalizationSettings.PersonalizationSettingsPanel = PersonalizationSettingsPanel;

 })(window);